export default "__VITE_ASSET__DesP$I3U__"